// jQuery(document).ready(function(){setTimeout(()=>{var chatIframe=$("#dummy-chat-button-iframe"),chatButton=chatIframe.contents().find(".mobile-only");chatButton&&(chatButton.css("height","30px"),chatButton.css("width","30px"))},1500)}),jQuery(document).ready(function(){$(".size-chart-slider").owlCarousel({loop:!1,margin:10,nav:!1,items:1,dots:!0}),$("#sizeOpen").click(function(){$("#size-popup").fadeIn();var dataSize=parseInt($("#size-popup").data("attr"));console.log(dataSize,"size"),dataSize<=24?($(".size-chart-slider").trigger("to.owl.carousel",0),console.log("micro")):dataSize>=25&&dataSize<=29?($(".size-chart-slider").trigger("to.owl.carousel",1),console.log("mini")):($(".size-chart-slider").trigger("to.owl.carousel",2),console.log("medium"))})}),document.addEventListener("DOMContentLoaded",function(){var splide=new Splide(".splide").mount()}),jQuery(document).ready(function(){jQuery("#sizeOpen").click(function(){jQuery("#size-popup").fadeIn()}),jQuery("#closePop").click(function(){jQuery("#size-popup").fadeOut()})}),$(document).ready(function(){var initialSize=parseInt($("#size-popup2").data("attr"));$(".range-item > p.bagsize-label span").text(initialSize),$(".range-item .bagsize-slider").val(initialSize).attr("max",30).attr("min",20).attr("value",initialSize).attr("step",5),setBagImageTransformation(initialSize),$("#sizeOpen2").click(function(){$("#size-popup2").fadeIn(),$("body").addClass("no-scroll"),_size=initialSize,$(".range-item > p.bagsize-label span").text(initialSize),$(".range-item .bagsize-slider").val(initialSize).attr("max",30).attr("min",20).attr("value",initialSize).attr("step",5)});var slider_oldVal=0,ctr=1,new_h=1;$(".range-item .bagsize-slider").on("input",function(e){var current_size=$(this).val();$(".range-item > p.bagsize-label span").text(current_size),setBagImageTransformation(current_size),slider_oldVal=current_size});function setBagImageTransformation(size){size==20?new_h=.9:size==25?new_h=1.04:size==30&&(new_h=1.11),$(".model-wrapper #bag-image").css("transform","scale("+new_h.toFixed(2)+")"),console.log(new_h.toFixed(2),"=>",size)}}),$("#sizeOpen3").click(function(){$("#size-popup3").fadeIn(),$("body").addClass("no-scroll")}),$("#closePop3").click(function(){$("#size-popup3").fadeOut(),$("body").removeClass("no-scroll")});var _size=0;$("#sizeOpen2").click(function(){$("#size-popup2").fadeIn(),$("body").addClass("no-scroll"),_size=parseInt($("#sizeOpen2 #size-popup2").data("attr")),$(".range-item > p.bagsize-label span").text($("#sizeOpen2 #size-popup2").data("attr")),$(".range-item .bagsize-slider").val(parseInt($("#sizeOpen2 #size-popup2").data("attr"))).attr("max",30).attr("min",20).attr("value",parseInt($("#sizeOpen2 #size-popup2").data("attr"))).attr("step",5)});var slider_oldVal_model=0,ctr_model=1,new_h_model=1;$(".range-item .modelsize-slider").on("input",function(e){var current_size=$(this).val(),_s=parseFloat(current_size)+4+"\u201D",final_s=_s.replace(".","\u2019");$(".range-item > p.heightmodel").text(final_s),slider_oldVal_model>current_size?ctr_model=ctr_model-.01:ctr_model=ctr_model+.01,new_h_model=ctr_model,console.log(current_size),console.log(new_h_model),$(".model-wrapper #model-image").css("transform","scale("+new_h_model.toFixed(2)+")"),slider_oldVal_model=current_size}),$("#closePop2").click(function(){$("#size-popup2").fadeOut(),$("body").removeClass("no-scroll")}),(document.getElementById("pop-cart")||{addEventListener:function(){}}).addEventListener("click",function(){var a=document.getElementById("addToCartButton");a&&a.click()}),(document.getElementById("pop-cart2")||{addEventListener:function(){}}).addEventListener("click",function(){var r=document.getElementsByClassName("studio-seizh-restock-button")[0];r&&r.click()});
// //# sourceMappingURL=/s/files/1/0753/4474/0633/t/2/assets/custom.js.map?v=1711905488

/* Essential Upsell cross-sell popup — NDG Popups V1, Popup 02 (rebuild).

   The app injects a <dialog> with obfuscated, deeply-nested markup that is
   painful to restyle in place, so we parse it, hide it, and render our own card
   (.ndg-upsell in custom.css) from its data.

   The purchase path does NOT proxy the app's React button (synthetic clicks on
   its controlled checkbox / disabled button don't register reliably). Instead we
   add the item ourselves. Their bundle (design/upsell.js) shows the discount is
   not a code — the app adds the add-on with a single line-item property,
   `__essential_upsell_funnel_id: <funnel id>`, and a backend Shopify discount
   function reads it to apply the price. So our own /cart/add.js with that same
   property gets the same discounted price, regardless of who added the line.

   Both ids are in the popup DOM: the funnel id on the dialog
   (data-essential-upsell-funnel-id) and the variant id on each product's
   discounted-price element (data-variant-id).

   Notes:
   - The add uses XMLHttpRequest, not fetch: the app overrides window.fetch to
     watch for /cart/add and would re-process our own add.
   - After adding we fire the theme's own "baseline:modalcart:afteradditem" on
     document.body, which is what the theme dispatches after its native add — the
     cart drawer re-fetches and opens.
   - The countdown keeps running inside the app's hidden tree; we mirror its text
     via a MutationObserver.
   - The add-on is checked by default per the design (Popup 02, note 5).

   IMPORTANT: verify a real cart shows the discounted price after adding — the
   property-based discount should apply, but it must be confirmed live. */
(function () {
  var DIALOG_SELECTOR = 'dialog[id^="essential-upsell-popup-dialog-"]';
  var ADD_EVENT = "baseline:modalcart:afteradditem";
  var X_SVG =
    '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>';

  function textOf(el) {
    return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : "";
  }
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function timerHtml(t) {
    return esc(t).replace(/(\d{1,2}:\d{2}(?::\d{2})?)/, "<strong>$1</strong>");
  }

  function readFunnelId(dialog) {
    if (dialog.getAttribute("data-essential-upsell-funnel-id")) {
      return dialog.getAttribute("data-essential-upsell-funnel-id");
    }
    var el = dialog.querySelector("[data-essential-upsell-funnel-id]");
    return el ? el.getAttribute("data-essential-upsell-funnel-id") : "";
  }

  function readTimer(dialog) {
    var container = dialog.querySelector('[data-essential-upsell-element="container"]');
    return container && container.firstElementChild ? textOf(container.firstElementChild) : "";
  }

  function readProducts(dialog) {
    var nodes = dialog.querySelectorAll('[data-essential-upsell-element="product"]');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var p = nodes[i];
      var link = p.querySelector('a[data-essential-upsell-element="title"]');
      if (!link) continue; // skip the app's empty placeholder slide
      var disc = p.querySelector('[data-essential-upsell-element="discounted-price"]');
      var variantId = disc ? disc.getAttribute("data-variant-id") : "";
      if (!variantId) continue; // can't add without a variant
      var img = p.querySelector('[data-essential-upsell-element="image"]');
      out.push({
        variantId: variantId,
        name: textOf(link),
        url: link.getAttribute("href") || "#",
        img: img ? img.getAttribute("src") || img.getAttribute("data-src") || "" : "",
        now: textOf(disc),
        was: textOf(p.querySelector('[data-essential-upsell-element="regular-price"]'))
      });
    }
    return out;
  }

  function productHtml(p, index) {
    return (
      '<div class="ndg-upsell__product is-checked" role="checkbox" tabindex="0"' +
      ' aria-checked="true" data-ndg-product="' + index + '">' +
      '<span class="ndg-upsell__check"></span>' +
      '<span class="ndg-upsell__thumb">' +
      (p.img ? '<img src="' + esc(p.img) + '" alt="">' : "") +
      "</span>" +
      '<span class="ndg-upsell__info">' +
      '<a class="ndg-upsell__name" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.name) + "</a>" +
      '<span class="ndg-upsell__price">' +
      (p.now ? '<span class="ndg-upsell__now">' + esc(p.now) + "</span>" : "") +
      (p.was ? '<span class="ndg-upsell__was">' + esc(p.was) + "</span>" : "") +
      "</span>" +
      "</span>" +
      "</div>"
    );
  }

  // Add via XHR so the app's fetch override doesn't re-process our own add.
  function addItems(items, done) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/add.js", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onload = function () {
      done(xhr.status >= 200 && xhr.status < 300);
    };
    xhr.onerror = function () {
      done(false);
    };
    xhr.send(JSON.stringify({ items: items }));
  }

  function build(dialog) {
    if (dialog.dataset.ndgUpsell) return;

    var funnelId = readFunnelId(dialog);
    var products = readProducts(dialog);
    // Nothing usable yet (app may still be populating) — try again on the next
    // mutation rather than rendering an empty card.
    if (!funnelId || !products.length) return;

    dialog.dataset.ndgUpsell = "1";
    dialog.classList.add("ndg-upsell-taken");

    // Neutralise the app dialog reliably. A class or inline style on it is wiped
    // whenever React re-renders the dialog (every timer tick), which is why it
    // kept reappearing over our card and swallowing clicks. Instead move it into
    // a hidden host: the app portals its content into this <dialog>, so React
    // keeps updating the dialog's children (the countdown) but does not manage
    // its parent — it cannot move it back out. Inline display:none is a belt-and
    // -suspenders in case a stray reference keeps it elsewhere.
    var host = document.getElementById("ndg-upsell-host");
    if (!host) {
      host = document.createElement("div");
      host.id = "ndg-upsell-host";
      host.style.cssText = "display:none !important";
      document.body.appendChild(host);
    }
    dialog.style.setProperty("display", "none", "important");
    host.appendChild(dialog);

    var appClose = dialog.querySelector('[data-essential-upsell-element="close-button"]');
    var headTitle = textOf(dialog.querySelector('div[data-essential-upsell-element="title"]')) || "Goes well with";
    var appCta = dialog.querySelector('[data-essential-upsell-element="add-to-cart-button"]');
    var ctaLabel = appCta ? textOf(appCta) : "Add to cart";
    var allButtons = dialog.querySelectorAll("button");
    var appSkip = allButtons.length ? allButtons[allButtons.length - 1] : appClose;
    var skipLabel = appSkip ? textOf(appSkip) : "Close";

    // Selection state — all checked by default (design note 5).
    var selected = products.map(function () {
      return true;
    });

    var overlay = document.createElement("div");
    overlay.className = "ndg-upsell";
    overlay.innerHTML =
      '<div class="ndg-upsell__backdrop" data-ndg-close></div>' +
      '<div class="ndg-upsell__card" role="dialog" aria-modal="true" aria-label="' + esc(headTitle) + '">' +
      '<div class="ndg-upsell__head">' +
      '<h3 class="ndg-upsell__title">' + esc(headTitle) + "</h3>" +
      '<button type="button" class="ndg-upsell__x" data-ndg-close aria-label="Close">' + X_SVG + "</button>" +
      "</div>" +
      '<div class="ndg-upsell__timer" data-ndg-timer>' + timerHtml(readTimer(dialog)) + "</div>" +
      '<div class="ndg-upsell__list">' + products.map(productHtml).join("") + "</div>" +
      '<button type="button" class="ndg-upsell__cta" data-ndg-cta>' + esc(ctaLabel) + "</button>" +
      '<button type="button" class="ndg-upsell__skip" data-ndg-skip>' + esc(skipLabel) + "</button>" +
      "</div>";
    document.body.appendChild(overlay);

    var ctaEl = overlay.querySelector("[data-ndg-cta]");

    function syncCta() {
      ctaEl.disabled = selected.indexOf(true) === -1;
    }

    function toggle(index) {
      selected[index] = !selected[index];
      var row = overlay.querySelector('[data-ndg-product="' + index + '"]');
      if (row) {
        row.classList.toggle("is-checked", selected[index]);
        row.setAttribute("aria-checked", selected[index] ? "true" : "false");
      }
      syncCta();
    }

    var observer = null;
    var dismissed = false;
    function dismiss() {
      if (dismissed) return; // our close click also fires the dialog 'close' event
      dismissed = true;
      if (observer) observer.disconnect();
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.style.removeProperty("overflow");
      // Reset takeover so a reopened dialog is rebuilt from scratch.
      dialog.classList.remove("ndg-upsell-taken");
      delete dialog.dataset.ndgUpsell;
      // Let the app close its own dialog so it records the dismissal, then make
      // sure it is actually closed (the click runs on a now-hidden element).
      if (appClose) appClose.click();
      dialog.removeAttribute("open");
      if (typeof dialog.close === "function") {
        try {
          dialog.close();
        } catch (e) {
          /* already closed */
        }
      }
    }

    function confirm() {
      var items = [];
      for (var i = 0; i < products.length; i++) {
        if (!selected[i]) continue;
        items.push({
          id: Number(products[i].variantId),
          quantity: 1,
          properties: funnelId ? { __essential_upsell_funnel_id: funnelId } : {}
        });
      }
      if (!items.length) return;

      ctaEl.classList.add("is-loading");
      ctaEl.disabled = true;
      addItems(items, function (ok) {
        ctaEl.classList.remove("is-loading");
        if (!ok) {
          syncCta();
          return;
        }
        dismiss();
        // Refresh + open the theme's cart drawer the way the theme itself does.
        document.body.dispatchEvent(new CustomEvent(ADD_EVENT));
      });
    }

    overlay.addEventListener("click", function (event) {
      var t = event.target;
      var row = t.closest ? t.closest("[data-ndg-product]") : null;
      if (row && !(t.closest && t.closest(".ndg-upsell__name"))) {
        toggle(parseInt(row.getAttribute("data-ndg-product"), 10));
        return;
      }
      if (t.closest && t.closest("[data-ndg-cta]")) {
        confirm();
        return;
      }
      if (t.closest && (t.closest("[data-ndg-close]") || t.closest("[data-ndg-skip]"))) {
        dismiss();
      }
    });

    overlay.addEventListener("keydown", function (event) {
      var row = event.target.closest ? event.target.closest("[data-ndg-product]") : null;
      if (row && (event.key === " " || event.key === "Enter")) {
        event.preventDefault();
        toggle(parseInt(row.getAttribute("data-ndg-product"), 10));
      }
      if (event.key === "Escape") dismiss();
    });

    // Mirror the app's live countdown into our timer, and re-assert that the app
    // dialog stays hidden and parked in the host — the timer tick fires this
    // every second, so any React attempt to un-hide or re-insert it is undone
    // right away.
    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        var timerEl = overlay.querySelector("[data-ndg-timer]");
        if (timerEl) timerEl.innerHTML = timerHtml(readTimer(dialog));
        if (dialog.style.display !== "none") {
          dialog.style.setProperty("display", "none", "important");
        }
        if (dialog.parentNode !== host) host.appendChild(dialog);
      });
      observer.observe(dialog, { childList: true, subtree: true, characterData: true });
    }

    dialog.addEventListener("close", dismiss);
    document.body.style.setProperty("overflow", "hidden");
    syncCta();
    overlay.querySelector(".ndg-upsell__x").focus();
  }

  function tryBuild(dialog) {
    if (dialog.dataset.ndgUpsell) return;
    if (!dialog.hasAttribute("open")) return; // wait until it's shown
    build(dialog); // no-ops (without marking) until funnel id + products exist
  }

  // Watch each dialog for both being opened and being populated. The app reuses
  // one <dialog> and toggles it via the `open` attribute (not a childList
  // change) and fills it asynchronously — a plain childList observer misses the
  // reopen, which is why the app's own card was still showing.
  var watched = new WeakSet();
  function watchDialog(dialog) {
    if (watched.has(dialog)) return;
    watched.add(dialog);
    tryBuild(dialog);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        tryBuild(dialog);
      }).observe(dialog, {
        attributes: true,
        attributeFilter: ["open"],
        childList: true,
        subtree: true
      });
    }
  }

  function scan() {
    var dialogs = document.querySelectorAll(DIALOG_SELECTOR);
    for (var i = 0; i < dialogs.length; i++) watchDialog(dialogs[i]);
  }

  if (window.MutationObserver) {
    // Catch the dialog being inserted; watchDialog then tracks its open/populate.
    new MutationObserver(scan).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
})();

/* Mobile sticky add-to-cart bar (snippets/product-sticky-atc.liquid).

   The bar's button does not add to the cart. It clicks the real
   #addToCartButton, which is a submit inside the Alpine-managed product form
   that the theme intercepts for the AJAX cart and drawer. Delegating keeps
   analytics, the selected variant, sold-out/preorder states and the drawer
   identical for both buttons; reimplementing /cart/add.js here would duplicate
   that and drift from it.

   Price and disabled state are mirrored from the live DOM rather than tracked
   here, so variant switches are picked up without this code knowing anything
   about variants. [data-product-price] is the span Alpine rewrites on change.

   Visibility is driven by whether the real buy buttons are on screen, so the
   bar never duplicates a CTA the customer can already see. Desktop is hidden in
   CSS, so there is no breakpoint duplicated here. */
(function () {
  function init() {
    var bar = document.querySelector("[data-sticky-atc]");
    if (!bar) return;

    var button = bar.querySelector("[data-sticky-atc-button]");
    var priceOut = bar.querySelector("[data-sticky-atc-price]");
    var realAtc = document.getElementById("addToCartButton");
    var ctaArea = document.querySelector(".add-to-cart-container");
    if (!button || !realAtc) return;

    button.addEventListener("click", function () {
      if (realAtc.disabled) return;
      realAtc.click();
    });

    function sync() {
      button.disabled = !!realAtc.disabled;
      var priceEl = document.querySelector("[data-product-price]");
      if (!priceEl || !priceOut) return;
      var text = (priceEl.textContent || "").replace(/\s+/g, " ").trim();
      if (text) priceOut.textContent = text;
    }

    sync();

    if (window.MutationObserver) {
      var observer = new MutationObserver(sync);
      // Alpine toggles disabled via :disabled, which lands as an attribute.
      observer.observe(realAtc, { attributes: true, attributeFilter: ["disabled"] });
      var priceEl = document.querySelector("[data-product-price]");
      if (priceEl) {
        observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
      }
    }

    if (window.IntersectionObserver && ctaArea) {
      new IntersectionObserver(function (entries) {
        // Class rather than the hidden attribute: the design slides the bar in,
        // and display:none would skip the transition.
        bar.classList.toggle("is-visible", !entries[0].isIntersecting);
      }).observe(ctaArea);
    } else {
      // No observer support: showing the bar is better than a CTA that never appears.
      bar.classList.add("is-visible");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* Sticky header offset for the product page columns.

   lg:top-sticky-header (the sticky product column and the gallery) takes its
   top offset from --sticky-header-height, which the theme only sets to the
   header height when its own "sticky header" setting is on. That setting is
   off here, so the theme writes 0, while custom.css makes
   #shopify-section-header sticky regardless. The columns therefore stuck at
   the very top of the viewport, underneath the header, and the title was
   clipped. The previous fix was a 90px padding-top on .product-block-area,
   which also opened a 90px gap under the header at the top of the page.

   Measure the header instead and publish its real height as the variable, so
   the columns stick just below it. Set as an inline custom property on <html>
   it wins over the theme's :root rule without !important, and a
   ResizeObserver keeps it right when the logo loads or the viewport changes.
   Rounded up so a fractional header height can never clip the first line. */
(function () {
  var header = document.getElementById("shopify-section-header");
  if (!header) return;

  function sync() {
    var height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty("--sticky-header-height", height + "px");
  }

  sync();
  if (window.ResizeObserver) {
    new ResizeObserver(sync).observe(header);
  } else {
    window.addEventListener("resize", sync);
  }
})();

/* Collection "show more" pagination (sections/main-collection.liquid).

   The grid paginates server-side; instead of prev / next it shows "N of M
   products" and a link to the next page, labelled "Show more (45)" or, when
   the next page is the last, "View all products (M)". Each click fetches
   that one page of the same section (section_id rendering; the link's own
   query string carries the current filters and sort) and appends its cards
   under the grid. The fetched page brings the block back with the next
   link and label, or without a link on the last page. Without JS the link
   opens the next page.

   Delegated from the document because the theme's AJAX filters replace
   #CollectionProductGrid, this block included, on every filter change.
   Fetched pages restart their own row logic, so their "after row"
   description / marquee rows and last-row filler cells are dropped, and
   the fillers are rebuilt once at the end with the same arithmetic as the
   Liquid so the final row keeps its background cells on both breakpoints. */
(function () {
  var busy = false;

  function products(list) {
    return Array.prototype.filter.call(list.children, function (li) {
      return li.getAttribute("role") !== "presentation" && !li.classList.contains("col-span-full");
    });
  }

  function removeFillers(list) {
    Array.prototype.forEach.call(list.querySelectorAll(":scope > li[role='presentation']"), function (li) {
      li.remove();
    });
  }

  function filler(className) {
    var li = document.createElement("li");
    li.className = className;
    li.setAttribute("aria-hidden", "true");
    li.setAttribute("role", "presentation");
    return li;
  }

  function rebuildFillers(list) {
    removeFillers(list);
    var items = products(list);
    if (!items.length) return;
    var cols = parseInt(list.dataset.cols, 10) || 1;
    var colsMobile = parseInt(list.dataset.colsMobile, 10) || 1;
    var gridCols = parseInt(list.dataset.gridCols, 10) || 12;
    var background = (items[0].className.match(/\bbg-[a-z]+-background\b/) || [""])[0];
    var rest = items.length % cols;
    if (rest) {
      list.appendChild(filler("none absolute lg:static lg:block lg:col-span-" + (cols - rest) * Math.floor(gridCols / cols) + " " + background));
    }
    var restMobile = items.length % colsMobile;
    if (restMobile) {
      list.appendChild(filler("block lg:none lg:absolute col-span-" + (colsMobile - restMobile) * Math.floor(2 / colsMobile) + " " + background));
    }
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-collection-show-more-button]");
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    var section = document.getElementById("main-collection-product-grid");
    var list = document.querySelector("#CollectionProductGrid .collection-list");
    if (!section || !list || !window.fetch || !window.URL) {
      window.location.href = button.href;
      return;
    }
    busy = true;
    load(button);

    function load(link) {
      link.setAttribute("aria-busy", "true");
      link.textContent = link.getAttribute("data-loading-text") || link.textContent;
      var url = new URL(link.href, window.location.href);
      url.searchParams.set("section_id", section.dataset.id);
      fetch(url.toString(), { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.text();
        })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, "text/html");
          var fetched = page.querySelector("#CollectionProductGrid .collection-list");
          if (!fetched) throw new Error("No product grid in the response");
          removeFillers(list);
          products(fetched).forEach(function (li) {
            list.appendChild(li);
          });
          var block = page.querySelector("[data-collection-show-more]");
          var current = document.querySelector("[data-collection-show-more]");
          if (block && current) {
            current.replaceWith(block);
          } else if (current) {
            current.remove();
          }
          rebuildFillers(list);
          busy = false;
        })
        .catch(function () {
          // Fall back to the plain page so the customer is never stuck.
          window.location.href = link.href;
        });
    }
  });
})();
/* Horizontal rail carousels (Community "Worn by you", product recommendations).
   Any [data-rail-root] containing a scrollable [data-rail] plus
   [data-rail-prev]/[data-rail-next] buttons gets prev/next behaviour for free —
   one delegated handler serves every rail, so sections need no JS of their own.
   Buttons are hidden below 1024px by snippets/carousel-nav.liquid. */
(function () {
  function stepFor(rail) {
    var card = rail.firstElementChild;
    if (!card) return rail.clientWidth * 0.8;
    var styles = window.getComputedStyle(rail);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function syncRoot(root) {
    var rail = root.querySelector("[data-rail]");
    if (!rail) return;
    var prev = root.querySelector("[data-rail-prev]");
    var next = root.querySelector("[data-rail-next]");
    var nav = root.querySelector(".rail-nav");

    // Everything already fits — there is nowhere to scroll, so hide the controls.
    // +1 absorbs sub-pixel rounding, which otherwise reports a phantom overflow.
    var overflows = rail.scrollWidth > rail.clientWidth + 1;
    if (nav) nav.classList.toggle("rail-nav--hidden", !overflows);
    if (!overflows) return;

    // -1 absorbs sub-pixel rounding so the end state is reliable.
    var max = rail.scrollWidth - rail.clientWidth - 1;
    if (prev) prev.disabled = rail.scrollLeft <= 0;
    if (next) next.disabled = rail.scrollLeft >= max;
  }

  function syncAll() {
    var roots = document.querySelectorAll("[data-rail-root]");
    for (var i = 0; i < roots.length; i++) syncRoot(roots[i]);
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest("[data-rail-prev], [data-rail-next]");
    if (!button || button.disabled) return;
    var root = button.closest("[data-rail-root]");
    var rail = root && root.querySelector("[data-rail]");
    if (!rail) return;
    event.preventDefault();
    var delta = button.hasAttribute("data-rail-prev") ? -stepFor(rail) : stepFor(rail);
    if (rail.scrollBy) rail.scrollBy({ left: delta, behavior: "smooth" });
    else rail.scrollLeft += delta;
  });

  // Scroll events don't bubble, so listen during the capture phase.
  document.addEventListener(
    "scroll",
    function (event) {
      var el = event.target;
      if (!el || el.nodeType !== 1 || !el.hasAttribute || !el.hasAttribute("data-rail")) return;
      var root = el.closest("[data-rail-root]");
      if (root) syncRoot(root);
    },
    true
  );

  window.addEventListener("resize", syncAll);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll);
  } else {
    syncAll();
  }
  // Product recommendations are fetched after load, so re-sync when rails appear.
  if (window.MutationObserver) {
    var raf = window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : function (fn) {
          return window.setTimeout(fn, 16);
        };
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      raf(function () {
        queued = false;
        syncAll();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Judge.me testimonials widget overrides:
   - .jdgm-widget.jdgm-testimonials-carousel : drop the app's inline --max-width /
     --card-color custom properties, force a black background
   - .jdgm-header / .jdgm-content            : margin-bottom 0
   - .jdgm-testimonials-container            : drop the 200px min-height

   Set as inline !important because app stylesheets often use !important themselves,
   and an inline !important declaration always wins.
   Judge.me injects (and can re-render) its widget asynchronously, so running once on
   DOMContentLoaded is not enough — a throttled MutationObserver re-applies whenever
   the widget appears or the app rewrites its inline styles. */
(function () {
  var CAROUSEL = ".jdgm-widget.jdgm-testimonials-carousel";
  var NO_BOTTOM_MARGIN = ".jdgm-header, .jdgm-content";
  var CONTAINER = ".jdgm-testimonials-container";

  function each(selector, fn) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i] && nodes[i].style) fn(nodes[i]);
    }
  }

  function apply() {
    each(CAROUSEL, function (el) {
      // removeProperty only clears INLINE custom properties, which is where the
      // Judge.me app writes its per-widget settings.
      el.style.removeProperty("--max-width");
      el.style.removeProperty("--card-color");
      el.style.setProperty("background", "#000000", "important");
    });

    // Collapse the stacked bottom margins above the carousel.
    each(NO_BOTTOM_MARGIN, function (el) {
      el.style.setProperty("margin-bottom", "0", "important");
    });

    // Drop the reserved min-height so the container hugs its content.
    each(CONTAINER, function (el) {
      el.style.setProperty("min-height", "0", "important");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }

  if (window.MutationObserver) {
    var raf = window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : function (fn) {
          return window.setTimeout(fn, 16);
        };
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      raf(function () {
        scheduled = false;
        apply();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* NDG PDP — "Buy now": add the selected variant to the cart, then go to checkout.
   Uses event delegation so it survives Alpine re-renders, and reads the variant from
   the product form itself (no Liquid interpolated into JS).
   Registered at the top of this file on purpose: code further down uses unguarded
   getElementById() and can throw, which would stop later listeners from binding. */
document.addEventListener("click", function (event) {
  var target = event.target;
  if (!target || !target.closest) return;

  var button = target.closest("[data-buy-now]");
  if (!button || button.disabled) return;

  event.preventDefault();

  var form = button.closest("form");
  if (!form) return;

  var idField = form.querySelector('[name="id"]');
  var variantId = idField && idField.value;
  if (!variantId) return;

  var quantityField = form.querySelector('[name="quantity"]');
  var quantity = parseInt(quantityField && quantityField.value, 10);
  if (!quantity || quantity < 1) quantity = 1;

  button.setAttribute("disabled", "disabled");

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error("Add to cart failed");
      return response.json();
    })
    .then(function () {
      window.location.href = "/checkout";
    })
    .catch(function () {
      button.removeAttribute("disabled");
    });
});

// var myElement = document.getElementById("dummy-chat-button");
// myElement.style.width = "40px";
// myElement.style.height = "40px";

//document.addEventListener('DOMContentLoaded', function() {
  //const currentPath = window.location.pathname;
  //if (currentPath === '/pages/getcode') {
    //document.body.classList.add('get-code');
  //}
//});

//document.addEventListener("DOMContentLoaded", function() {
  //const urlParams = new URLSearchParams(window.location.search);
  //const accessValue = urlParams.get('access');

  //if (accessValue) {
    //const inputField = document.getElementById('locksmith_passcode');
    //if (inputField) {
      //inputField.value = 'ARCHIVE25';
    //}
  //}
//});

$(document).ready(function() {
  const endDate = new Date(2025, 11, 2, 16, 0, 0).getTime();
  const x = setInterval(function() {
    const now = new Date().getTime();

    const distance = endDate - now;
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    $('#countdown').html(
      days + "d " +
      hours + "h " +
      minutes + "m " +
      seconds + "s "
    );

    if (distance < 0) {
      clearInterval(x);
      $('#countdown').html("EXPIRED");
    }
  }, 1000);
});

document.addEventListener("DOMContentLoaded", function() {
    const targetID = 'locksmith_passcode';
    const defaultPasscode = 'ARCHIVE25';
    const parentSelector = 'body';
    
    const urlParams = new URLSearchParams(window.location.search);
    const accessValue = urlParams.get('access');

    if (!accessValue) {
        return;
    }
    
    function fillPasscode(observerInstance) {
        const inputField = document.getElementById(targetID);
        
        if (inputField) {

            inputField.value = defaultPasscode;
            console.log(`Passcode Filler: Passcode set to '${defaultPasscode}' in #${targetID}.`);
            inputField.dispatchEvent(new Event('change', { bubbles: true }));
            
            if (observerInstance) {
                observerInstance.disconnect();
                console.log("Passcode Filler: Observer disconnected.");
            }
            return true;
        }
        return false;
    }

    if (fillPasscode(null)) {
        return;
    }

    console.log("Passcode Filler: Element not found immediately. Starting observer.");
    
    const observer = new MutationObserver(function(mutations, me) {
        if (fillPasscode(me)) {
            return; 
        }
    });

    observer.observe(document.querySelector(parentSelector), {
        childList: true,
        subtree: true
    });
});

jQuery(document).ready(function () {
 
  setTimeout(() => {
    var chatIframe = $("#dummy-chat-button-iframe");
    var chatButton = chatIframe.contents().find(".mobile-only");

    if (chatButton) {
      chatButton.css("height", "30px");
      chatButton.css("width", "30px");
    }
  }, 1500);

  //modal black friday
  var modal = jQuery("#bfModal");
  var openBtn = jQuery("#openBFModal");
  var closeBtn = jQuery(".close-btn");

  openBtn.on("click", function() {
    modal.show();
  });

  closeBtn.on("click", function() {
    modal.hide();
  });

  // close modal when clicking outside the modal
  //jQuery(window).on("click", function(event) {
    //if (jQuery(event.target).is(modal)) {
      //modal.hide();
    //}
  //});

});

jQuery(document).ready(function () {
  //$(".accelerated-checkout-button").addClass("newClass");
//  $("gravity-button").css('--gravity-button-display', 'flex');
  
  $(".size-chart-slider").owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    items: 1,
    dots: true,
  });

  $("#sizeOpen").click(function () {
    $("#size-popup").fadeIn();

    var dataSize = parseInt($("#size-popup").data("attr"));
    console.log(dataSize, "size");

    if (dataSize <= 24) {
      $(".size-chart-slider").trigger("to.owl.carousel", 0);
      console.log("micro");
    } else if (dataSize >= 25 && dataSize <= 29) {
      $(".size-chart-slider").trigger("to.owl.carousel", 1);
      console.log("mini");
    } else {
      $(".size-chart-slider").trigger("to.owl.carousel", 2);
      console.log("medium");
    }
  });
  
});

document.addEventListener("DOMContentLoaded", function () {
  var splide = new Splide(".splide").mount();
});

// size chart
jQuery(document).ready(function () {
  jQuery("#sizeOpen").click(function () {
    jQuery("#size-popup").fadeIn();
  });

  jQuery("#closePop").click(function () {
    jQuery("#size-popup").fadeOut();
  });

  // moi code
  $('div[x-ref="video_container"] > button').on('click', function () {
      setTimeout(function() {
        $('body.template-product ul.splide__list li video').attr('oncanplay', 'this.muted=true');
      },10);
  });

  // moi code: swipe for splide
  var startX, startY, distX, distY, swipeThreshold = 30;
  $('.splide').on('touchstart', function(e) {
    var touchStart = e.originalEvent.touches[0];
    startX = touchStart.pageX;
    startY = touchStart.pageY;
  });

  $('.splide').on('touchmove', function(e) {
    distX = e.originalEvent.touches[0].pageX - startX;
    distY = e.originalEvent.touches[0].pageY - startY;

    if (Math.abs(distX) > Math.abs(distY)) {
      e.preventDefault();
    }
  });

  $('.splide').on('touchend', function(e) {
    var touchEnd = e.originalEvent.changedTouches[0];
    distX = touchEnd.pageX - startX;
    distY = touchEnd.pageY - startY;

    if (Math.abs(distX) < swipeThreshold && Math.abs(distY) < swipeThreshold) {
      return;
    }

    if (Math.abs(distX) > Math.abs(distY)) {
      if (distX > 0) {
        // Swipe Right
        $('button.splide__arrow--prev').trigger('click');
      } else {
        // Swipe Left
        $('button.splide__arrow--next').trigger('click');
      }
    }
  });
  // moi end code: swipe for splide
});


$(document).ready(function () {
  var initialSize = parseInt($("#size-popup2").data("attr"));

  $(".range-item > p.bagsize-label span").text(initialSize);

  $(".range-item .bagsize-slider")
    .val(initialSize)
    .attr("max", 30)
    .attr("min", 20)
    .attr("value", initialSize)
    .attr("step", 5);

  setBagImageTransformation(initialSize);

  $("#sizeOpen2").click(function () {
    $("#size-popup2").fadeIn();
    $("body").addClass("no-scroll");
    _size = initialSize;
    $(".range-item > p.bagsize-label span").text(initialSize);
    $(".range-item .bagsize-slider")
      .val(initialSize)
      .attr("max", 30)
      .attr("min", 20)
      .attr("value", initialSize)
      .attr("step", 5);
  });

  var slider_oldVal = 0,
    ctr = 1,
    new_h = 1;

  $(".range-item .bagsize-slider").on("input", function (e) {
    var current_size = $(this).val();
    $(".range-item > p.bagsize-label span").text(current_size);
    setBagImageTransformation(current_size);

    slider_oldVal = current_size;
  });

  // function setBagImageTransformation(size) {
  //   if (size == 20) {
  //     new_h = 0.9;
  //   } else if (size == 25) {
  //     new_h = 1.04;
  //   } else if (size == 30) {
  //     new_h = 1.11;
  //   }

  //   $(".model-wrapper #bag-image").css(
  //     "transform",
  //     "scale(" + new_h.toFixed(2) + ")"
  //   );
  //   console.log(new_h.toFixed(2), "=>", size);
  // }
  function setBagImageTransformation(size) {
    const default_h = 1;  // Set a default value
    let new_h = default_h;
  
    if (size == 20) {
      new_h = 0.9;
    } else if (size == 25) {
      new_h = 1.04;
    } else if (size == 30) {
      new_h = 1.11;
    }
  
    $(".model-wrapper #bag-image").css(
      "transform",
      "scale(" + new_h.toFixed(2) + ")"
    );
    // console.log(new_h.toFixed(2), "=>", size);
  }
});

$("#sizeOpen3").click(function () {
  $("#size-popup3").fadeIn();
  $("body").addClass("no-scroll");
});
$("#closePop3").click(function () {
  $("#size-popup3").fadeOut();
  $("body").removeClass("no-scroll");
});

var _size = 0;
$("#sizeOpen2").click(function () {
  $("#size-popup2").fadeIn();
  $("body").addClass("no-scroll");
  _size = parseInt($("#sizeOpen2 #size-popup2").data("attr"));
  $(".range-item > p.bagsize-label span").text(
    $("#sizeOpen2 #size-popup2").data("attr")
  );
  $(".range-item .bagsize-slider")
    .val(parseInt($("#sizeOpen2 #size-popup2").data("attr")))
    .attr("max", 30)
    .attr("min", 20)
    .attr("value", parseInt($("#sizeOpen2 #size-popup2").data("attr")))
    .attr("step", 5);
});

// model size
var slider_oldVal_model = 0,
  ctr_model = 1,
  new_h_model = 1;
$(".range-item .modelsize-slider").on("input", function (e) {
  var current_size = $(this).val();
  var _s = parseFloat(current_size) + 4 + "”";
  var final_s = _s.replace(".", "’");
  $(".range-item > p.heightmodel").text(final_s);


  if (slider_oldVal_model > current_size) {
    ctr_model = ctr_model - 0.01 ?? 1;
  } else {
    ctr_model = ctr_model + 0.01 ?? 1;
  }
  new_h_model = ctr_model;

  console.log(current_size);
  console.log(new_h_model);

  $(".model-wrapper #model-image").css(
    "transform",
    "scale(" + new_h_model.toFixed(2) + ")"
  );
  slider_oldVal_model = current_size;
});

$("#closePop2").click(function () {
  $("#size-popup2").fadeOut();
  $("body").removeClass("no-scroll");
});

document.getElementById("pop-cart").addEventListener("click", function() {
    document.getElementById("addToCartButton").click();
});
document.getElementById("pop-cart2").addEventListener("click", function() {
    document.getElementsByClassName("studio-seizh-restock-button")[0].click();
});
